import Immutable from 'immutable';

/**
 * Transforms the input list by inserting an item produced by inBetweenItemProducer in between every item of the list,
 * while every item of the list being transformed by itemTransformer.
 * Both inBetweenItemProducer and itemTransformer are provided with index in newly constructed list.
 * @param list immutable list
 * @param itemTransformer (element, index) => element
 * @param inBetweenItemProducer (index) => element
 * @returns immutable list
 */
export function joinCollection(list, itemTransformer, inBetweenItemProducer) {
    if (list.isEmpty()) {
        return list;
    }
    return list
        .reduce(
            (reduction, val, i) => reduction.concat(itemTransformer(val, i * 2), inBetweenItemProducer(i * 2 + 1)),
            Immutable.List()
        )
        .butLast();
}

/**
 * Splits the list into chunks of constant size
 * @param list
 * @param chunkSize
 * @returns {Immutable.Iterable<number, any>}
 */
export function splitIntoChunks(list, chunkSize = 1) {
    return Immutable.Range(0, list.count(), chunkSize).map(chunkStart =>
        list.slice(chunkStart, chunkStart + chunkSize)
    );
}
